import { Component } from 'react';
import { ContactForm } from "./ContactForm/ContactForm";
import { ContactList } from './ContactList/ContactList';
import { Filter } from "./Filter/Filter";
import {AppContainer, Title, Header} from "./App.styled"


export class App extends Component {
  state = {
  contacts: [
    {id: 'id-1', name: 'Rosie Simpson', number: '459-12-56'},
    {id: 'id-2', name: 'Hermione Kline', number: '443-89-12'},
    {id: 'id-3', name: 'Eden Clements', number: '645-17-79'},
    {id: 'id-4', name: 'Annie Copeland', number: '227-91-26'},
  ],
  filter: '',
}
  addContact = newContact => {
    
    if (this.state.contacts.find(contact=> contact.name === newContact.name)) {
      return alert(`${newContact.name}: is already in contacts`)
    } else {
      this.setState(prevState => ({
        contacts: [...prevState.contacts, newContact]
      }))
    }
  }
 
  filterContacts = e => {
    this.setState({filter: e.target.value})
    };
  renderContacts = () => {
    return [...this.state.contacts].filter(contact=>contact.name.toLowerCase().includes(this.state.filter.toLowerCase()))  
  }


  deleteContact = (contactId) => {
    this.setState(prevState => ({
      contacts: prevState.contacts.filter(contact => contact.id !== contactId),
    }));
  };

  render()
 { return (
    <AppContainer>
      <Header>Phonebook</Header>
      <ContactForm onSave={this.addContact} />
      <Title>Contacts</Title>
      <Filter onInput={ this.filterContacts } />
      <ContactList contactsData={ this.renderContacts()} onDelete={ this.deleteContact}/>
    </AppContainer>
  )};
};
